/**
 * Pure helpers shared by the side nav items.
 */

export const toCamelCase = (str) => {
  return str.replaceAll(/-([a-z])/g, (match, letter) => letter.toUpperCase());
};

// Shared row layout for a nav item, with the depth-0 active highlight.
export const navRowSx = ({ active, depth, offset }) => ({
  alignItems: 'center',
  borderRadius: 1,
  display: 'flex',
  justifyContent: 'flex-start',
  pl: `${16 + offset}px`,
  py: '6px',
  textAlign: 'left',
  width: '100%',
  ...(active && depth === 0 && {
    backgroundColor: 'var(--nav-item-active-bg)',
  }),
  '&:hover': {
    backgroundColor: 'var(--nav-item-hover-bg)',
  },
});
